import { Container, Grid, Stack } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import pluralize from 'pluralize';
import React, { JSX } from 'react';

import Folded2025Card from '~components/business-owner/Folded2025/components/Folded2025Card';
import Folded2025Title from '~components/business-owner/Folded2025/components/Folded2025Title';
import { useFolded2025Data } from '~components/business-owner/Folded2025/hooks/useFolded2025Data';

import styles from './Folded2025Team.module.scss';

import ClockIcon from '../../assets/icons/Clock.svg?react';
import DeliveryIcon from '../../assets/icons/Delivery.svg?react';
import ScaleIcon from '../../assets/icons/Scale.svg?react';
import TeamIcon from '../../assets/Team_Icon.svg?react';

const Folded2025Team = (): JSX.Element => {
	const { data } = useFolded2025Data();
	const { routeManagement } = useFlags();

	return (
		<div className={styles.container}>
			<Container disableGutters>
				<Folded2025Title icon={<TeamIcon />}>Team</Folded2025Title>

				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Folded2025Card icon={<ScaleIcon />}>
							<Grid
								container
								spacing={2}
								sx={{
									alignItems: 'center',
									justifyContent: 'space-between',
								}}
							>
								<Grid item xs={12} md={8} order={{ xs: 2, md: 1 }}>
									<Folded2025Card.Value size="xl">
										{data?.summary?.team?.mvp_by_pounds?.name}
									</Folded2025Card.Value>
									<Folded2025Card.Label>
										{Number(
											data?.summary?.team?.mvp_by_pounds
												?.pounds_processed,
										).toLocaleString()}{' '}
										{pluralize(
											'pound',
											data?.summary?.team?.mvp_by_pounds
												?.pounds_processed,
										)}
									</Folded2025Card.Label>
								</Grid>
								<Grid item xs={12} md={4} order={{ xs: 1, md: 2 }}>
									<Folded2025Card.Label>
										Top processor in pounds
									</Folded2025Card.Label>
								</Grid>
							</Grid>
						</Folded2025Card>
					</Grid>{' '}
					{routeManagement && (
						<Grid item xs={12}>
							<Folded2025Card icon={<DeliveryIcon />}>
								<Grid
									container
									spacing={2}
									sx={{
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
								>
									<Grid item xs={12} md={8} order={{ xs: 2, md: 1 }}>
										<Folded2025Card.Value size="xl">
											{data?.summary?.team?.mvp_by_deliveries?.name}
										</Folded2025Card.Value>
										<Folded2025Card.Label>
											{Number(
												data?.summary?.team?.mvp_by_deliveries
													?.deliveries_completed,
											).toLocaleString()}{' '}
											{pluralize(
												'order',
												data?.summary?.team?.mvp_by_deliveries
													?.deliveries_completed,
											)}
										</Folded2025Card.Label>
									</Grid>
									<Grid item xs={12} md={4} order={{ xs: 1, md: 2 }}>
										<Folded2025Card.Label>
											Most number of orders delivered
										</Folded2025Card.Label>
									</Grid>
								</Grid>
							</Folded2025Card>
						</Grid>
					)}
					<Grid item xs={12}>
						<Folded2025Card icon={<ClockIcon />}>
							<Grid
								container
								spacing={2}
								sx={{
									alignItems: 'center',
									justifyContent: 'space-between',
								}}
							>
								<Grid item xs={12} md={8} order={{ xs: 2, md: 1 }}>
									<Folded2025Card.Value size="xl">
										{data?.summary?.team?.mvp_by_hours?.name}
									</Folded2025Card.Value>
									<Folded2025Card.Label>
										{Number(
											data?.summary?.team?.mvp_by_hours
												?.hours_clocked,
										).toLocaleString()}{' '}
										{pluralize(
											'hour',
											data?.summary?.team?.mvp_by_hours
												?.hours_clocked,
										)}
									</Folded2025Card.Label>
								</Grid>
								<Grid item xs={12} md={4} order={{ xs: 1, md: 2 }}>
									<Folded2025Card.Label>
										Most hours worked
									</Folded2025Card.Label>
								</Grid>
							</Grid>
						</Folded2025Card>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Folded2025Team;
